/**
 * 获取对象数组（array）中某一个对象（item）坐标
 * @param  {[type]} array [description]
 * @param  {[type]} item  [description]
 * @param  {[type]} key   [description]
 * @return {[type]}       [description]
 */
export function getIndex(array, item, key) {
  let index = -1
  let bool = false
  for (let i = 0; i < array.length; i++) {
    key
      ? typeof item === 'string'
        ? (bool = array[i][key] === item)
        : (bool = array[i][key] === item[key])
      : (bool = array[i] === item)
    if (bool) {
      index = i
      break
    }
  }
  return index
}

// 过滤数组元素
// array: 原始数组。必须。
// filter: 将被过滤掉的元素, 数组或单个数据。必须。
// key: 对象进行匹配的关键字，如id。filter为非数组时必须。
// function getIndex: 类似indexOf，主要用于数组元素为对象的数据匹配。
export function subArg(array, filter, key) {
  var getIndex = function(array, item, key) {
    var index = -1
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === item[key]) {
        index = i
        break
      }
    }
    return index
  }
  return array.filter(function(data) {
    if (filter instanceof Array) {
      if (!key) {
        return !filter.includes(data)
      } else {
        return getIndex(filter, data, key) === -1
      }
    } else {
      return data[key] !== filter[key]
    }
  })
}

export function by(name) {
  return function(o, p) {
    var a, b
    if (typeof o === 'object' && typeof p === 'object' && o && p) {
      a = o[name]
      b = p[name]
      if (a === b) {
        return 0
      }
      if (typeof a === typeof b) {
        return a < b ? -1 : 1
      }
      return typeof a < typeof b ? -1 : 1
    } else {
      throw new Error('error')
    }
  }
}

export function getIdArray(list, key) {
  let result = []
  for (let i = 0, il = list.length; i < il; i++) {
    result.push(list[i][key || 'id'])
  }
  return result
}

export function isJSON(str) {
  if (typeof str === 'string') {
    try {
      JSON.parse(str)
      return true
    } catch (e) {
      return false
    }
  } else {
    return false
  }
}

export function getCookie(name) {
  let cookie = document.cookie.split(';')
  let value = ''
  for (let data of cookie) {
    data = data.trim().split('=')
    if (data[0] === name) {
      value = data[1]
      break
    }
  }
  return value
}

// 一个简单的缓动函数
export function easeMoveTo(ele, target) {
  if (!ele) {
    // 获取实际滚动的文档对象
    ele = document.body.scrollTop ? document.body : document.documentElement
  }
  clearInterval(ele.timer)
  if(target > ele.scrollTop){
    ele.scrollTop = target
  }else{
    // 用定时器实现动画效果
    ele.timer = setInterval(() => {
      // 每次滚动的幅度。开始时最大，后逐渐减小。
      let step = (target - ele.scrollTop) / 5
      step = step > 0 ? Math.ceil(step) : Math.floor(step)
      // 如果step小于需要滚动的距离，就直接滚动到目标位置
      if (Math.abs(target - ele.scrollTop) <= Math.abs(step)) {
        ele.scrollTop = target
        clearInterval(ele.timer)
        ele.timer = null
      } else {
        ele.scrollTop += step
      }
    }, 10)
  }
  

}

// url格式验证
export function urlFormat(value) {
  if (!value) {
    return ''
  }
  let urlPattern = new RegExp(
    '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    'i'
  )
  let msg = 'Url Format Error'
  if (!(typeof value === 'string' && !!value.match(urlPattern))) {
    return msg
  } else {
    return ''
  }
}

// 邮箱格式校验
export function emailValidator(email) {
  if (typeof email !== 'string' || !email) {
    return false
  }
  // eslint-disable-next-line no-useless-escape
  let emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return emailPattern.test(email)
}

// 格式化为百分比
export function percentageFmt(val) {
  if (parseFloat(val) > 0 && parseFloat(val) < 1) {
    let len = String.prototype.slice.call(val, 2).length
    return len > 2 ? (val * 100).toFixed(2) + '%' : val * 100 + '%'
  } else {
    return val * 100 + '%'
  }
}

// 自动生成链接
export function generateUrl(host, path, query) {
  let key_value = []
  let params = ''
  for (let value in query) {
    if (query[value]) {
      key_value.push(`${value}=${query[value]}`)
    }
  }
  if (key_value.length) {
    params = key_value.join('&')
    params = '?' + params
  }
  return host + `/${path || ''}` + params
}

// 判断数组a是否包含数组b的元素
export function isContained(a, b) {
  if (!(a instanceof Array) || !(b instanceof Array)) {
    return false
  }
  if (a.length < b.length) {
    return false
  }
  var aStr = a.toString()
  for (let i = 0, len = b.length; i < len; i++) {
    if (aStr.indexOf(b[i]) === -1) {
      return false
    }
  }
  return true
}

// 判断两个数组是否有交集
export function hasIntersect(arr1, arr2) {
  if (Array.isArray(arr1) && Array.isArray(arr2)) {
    return (
      arr1.filter(function(v) {
        return arr2.includes(v)
      }).length > 0
    )
  }
}

// 对象数组去重
export function unique(list, key) {
  let obj = {}
  let result = []
  for (let item of list) {
    let value = item[key || 'id']
    if (!obj[value]) {
      obj[value] = 1
      result.push(item)
    }
  }

  return result
}

// 生成唯一id
export function generateGuuId() {
  var d = new Date().getTime()
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = (d + Math.random() * 16) % 16 | 0

    d = Math.floor(d / 16)

    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })

  return uuid
}

export function isAdBlock() {
  let adBlockEnabled = false
  let testAd = document.createElement('div')
  testAd.innerHTML = '&nbsp;'
  testAd.className = 'ads ad adsbox doubleclick ad-placement carbon-ads'
  document.body.appendChild(testAd)
  let p = new Promise((resolve, reject) => {
    window.setTimeout(() => {
      if (testAd.offsetHeight === 0) {
        adBlockEnabled = true
      }
      testAd.remove()
      resolve(adBlockEnabled)
    }, 100)
  })
  return p
}

// 删除参数对象中的空字符串, null, undefined
export function clearEmptyParam(params) {
  const keys = Object.keys(params)
  if (Object.keys(params).length) {
    keys.forEach(key => {
      if (['', null, undefined].includes(params[key])) {
        delete params[key]
      }
    })
  }
  return params
}

/**
 * js数值计算 示例：funCalc([1.02,3,4])
 * @param {*} arrList 参数数组
 * @param {*} operator 操作符：1加法 2乘法
 * @param {*} precision 精度 默认2位
 */
export function funCalc(arrList, operator = 1, precision = 2) {
  if (arrList.length === 0) return 0;
  // 计算最大数度值,避免精度丢失，先扩大位数，再缩小
  let mPow = Math.pow(10, precision); // 默认2位小数
  let total = 0;
  if (operator === 2) {
    total = 1;
    mPow = 1;
  }
  for (const item of arrList) {
    let tem = 0;
    if (item) {
      tem = parseFloat(item) ? parseFloat(item) : 0; // parseFloat处理，转化失败时给0
      tem = !isNaN(tem) ? tem : 0; // 处理 NaN 情况
    }
    switch (operator) {
      case 1:
        total += tem * mPow;
        break;
      case 2:
        total *= tem * mPow;
        break;
      default:
        total += tem * mPow;
    }
  }
  // toFixed部分浏览器会用问题，toFixed它是一个四舍六入五成双的诡异的方法(也叫银行家算法)，"四舍六入五成双"含义：对于位数很多的近似数，当有效位数确定后，其后面多余的数字应该舍去，只保留有效数字最末一位，这种修约（舍入）规则是“四舍六入五成双”，也即“4舍6入5凑偶”这里“四”是指≤4 时舍去，"六"是指≥6时进上，"五"指的是根据5后面的数字来定，当5后有数时，舍5入1；当5后无有效数字时，需要分两种情况来讲：①5前为奇数，舍5入1；②5前为偶数，舍5不进。（0是偶数）
  const res = (total / mPow).toFixed(precision);
  // 修复toFixed
  // const res = parseInt(total + 0.5, 10) / times;
  return Number(res);
}
